import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:ac04a7eb-f456-48c2-b9c0-a8a9a805f21d",
    aws_user_pools_id: "us-east-1_fEYTOxACg",
    aws_user_pools_web_client_id: "2tdn3rgdctsda7p10r8tdn1tg1",
    Auth: {
      identityPoolId: "us-east-1:ac04a7eb-f456-48c2-b9c0-a8a9a805f21d",
      region: "us-east-1",
      userPoolId: "us-east-1_fEYTOxACg",
      userPoolWebClientId: "2tdn3rgdctsda7p10r8tdn1tg1",
    },
    oauth: {
      domain: `whs-navigator-prod-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://prod.na.navigator.whs.amazon.dev",
      redirectSignOut: "https://prod.na.navigator.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
